import React from 'react';

import { SkeletonBlock } from '../../../components/skeleton/skeleton';

export default function ReceiptSkeleton() {
  return (
    <div className="order-shell min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
      <div className="mx-auto max-w-5xl space-y-8">
        <div className="flex items-center justify-between">
          <SkeletonBlock className="h-8 w-28 rounded-md" />
          <SkeletonBlock className="h-5 w-14 rounded" />
        </div>

        <div className="flex flex-col gap-2">
          <SkeletonBlock className="h-3 w-32 rounded" />
          <SkeletonBlock className="h-8 w-64 max-w-[90%] rounded-md sm:h-9" />
          <SkeletonBlock className="h-4 w-full max-w-xl rounded" />
        </div>

        <section className="flex flex-col gap-4 rounded-md border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <SkeletonBlock className="h-16 w-16 shrink-0 rounded-md" />
            <div className="min-w-0 space-y-2">
              <SkeletonBlock className="h-3 w-16 rounded" />
              <SkeletonBlock className="h-7 w-48 max-w-[70vw] rounded-md" />
              <SkeletonBlock className="h-3 w-full max-w-md rounded" />
            </div>
          </div>
        </section>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {[0, 1].map((i) => (
            <div
              key={i}
              className="overflow-hidden rounded-md border border-slate-200 shadow-sm dark:border-slate-700"
            >
              <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3 dark:border-slate-700/60">
                <SkeletonBlock className="h-7 w-7 rounded-md" />
                <SkeletonBlock className="h-3 w-36 rounded" />
              </div>
              <div className="px-5 py-5">
                <SkeletonBlock className="h-10 w-full max-w-xs rounded-md" />
              </div>
            </div>
          ))}
        </div>

        <div className="rounded-md border border-slate-200 bg-white dark:border-slate-700">
          <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3 dark:border-slate-700/60">
            <SkeletonBlock className="h-3 w-16 rounded" />
            <SkeletonBlock className="h-5 w-8 rounded-full" />
          </div>
          {[0, 1, 2].map((row) => (
            <div
              key={row}
              className="flex items-center gap-4 border-b border-slate-100 px-5 py-4 last:border-0 dark:border-slate-700/60"
            >
              <SkeletonBlock className="h-12 w-12 shrink-0 rounded-md" />
              <div className="min-w-0 flex-1 space-y-2">
                <SkeletonBlock className="h-4 w-48 max-w-[70%] rounded" />
                <SkeletonBlock className="h-3 w-24 rounded" />
              </div>
              <SkeletonBlock className="h-4 w-16 shrink-0 rounded" />
            </div>
          ))}
        </div>

        <div className="rounded-md border border-slate-200 bg-white p-5 dark:border-slate-700 dark:bg-slate-800">
          <div className="space-y-2">
            {[0, 1, 2, 3].map((r) => (
              <div key={r} className="flex justify-between gap-4">
                <SkeletonBlock className="h-3 w-24 rounded" />
                <SkeletonBlock className="h-3 w-16 rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
